module.exports = __webpack_public_path__ + "img/invoice.4d014d5c.svg";